/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
import { CopyrightDesktop } from '@/components/content/Footer/parts/CopyrightDesktop';
import { ID } from '@/data/types/Basic';
import { FC } from 'react';

export const Footer: FC<{
	id: ID;
	clickAction?: () => void;
}> = () => <CopyrightDesktop />;
